import { render, staticRenderFns } from "./SidebarLeft.vue?vue&type=template&id=a5abb9ba&scoped=true"
import script from "./SidebarLeft.vue?vue&type=script&lang=js"
export * from "./SidebarLeft.vue?vue&type=script&lang=js"
import style0 from "./SidebarLeft.vue?vue&type=style&index=0&id=a5abb9ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5abb9ba",
  null
  
)

export default component.exports